import styled from '@emotion/styled';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { formatMinToHours } from '../../utils/common_functions';

const ProjectBillingTooltip = ({ value, projectBilling }) => {
  return (
    <Tooltip
      overlayInnerStyle={{
        width: 300,
        // backgroundColor: '#d33232',
        backgroundColor: '#fff',
        color: '#fff'
      }}
      autoAdjustOverflow={true}
      placement="topLeft"
      trigger={['click', 'hover']}
      open={value > 0 ? undefined : false}
      title={
        <TooltipContainer>
          <HeadingRow>
            <Label style={{ fontSize: '10px' }} bold>
              SNO
            </Label>
            <Label bold>Project</Label>
            <Value bold>Hours</Value>
          </HeadingRow>
          <Container>
            {projectBilling?.map((item, index) => (
              <DetailRow key={index}>
                <Label>{index + 1}</Label>
                <Label>{item?.project_name}</Label>
                <Value>{formatMinToHours(item?.project_mins) || 0}</Value>
              </DetailRow>
            ))}
          </Container>
        </TooltipContainer>
      }>
      <SpanBox value={value}>{value > 0 ? formatMinToHours(value) : '-'}</SpanBox>
    </Tooltip>
  );
};

ProjectBillingTooltip.propTypes = {
  value: PropTypes.number,
  projectBilling: PropTypes.arrayOf(
    PropTypes.shape({
      project_name: PropTypes.string,
      project_mins: PropTypes.number
    })
  )
};

export default ProjectBillingTooltip;

// ---------------- STYLED ----------------
const TooltipContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
  background: #f9fafb;
  border-radius: 8px;
`;
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 6px 0;
  max-height: 250px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 3px;
    width: 3px;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.primaryColor};
    border-radius: 10px;
  }
`;

const SpanBox = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #313131;
  cursor: pointer;
  &:hover {
    text-decoration: ${({ value }) => (value ? 'underline' : 'none')};
    font-weight: 500;
    color: ${(props, value) => (value ? props.theme.primaryColor : ' #313131;')};
  }
`;

const GridRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 40px 1fr 100px; // fixed SNO + Hours, flex Project
  align-items: center;
  font-size: 13px;
  padding: 4px 8px;
`;

const HeadingRow = styled(GridRow)`
  background: #f0f0f0;
  border-radius: 6px;
  font-weight: 600;
`;

const DetailRow = styled(GridRow)`
  border-bottom: 1px dashed #e5e7eb;
  &:last-child {
    border-bottom: none;
  }
`;

const Label = styled.span`
  font-weight: ${(props) => (props.bold ? 600 : 500)};
  color: ${(props) => (props.bold ? '#000' : '#555')};
`;

const Value = styled.span`
  white-space: nowrap;
  font-weight: ${(props) => (props.bold ? 700 : 600)};
  color: ${(props) => props.theme.primaryColor};
  text-align: right;
`;
